import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, roles }) {
  const { user, checked } = useAuth();
  if (!checked || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0B192C]">
        <Loader2 className="animate-spin text-[#FF6500]" size={36} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "driver" ? "/driver" : "/admin"} replace />;
  }
  return children;
}
